import { chameleonComponents } from './components';
import { camelize } from './utils';
const getPropertyName = (attributeSet, fallbackProperty) => { var _a; return (_a = attributeSet.alias) !== null && _a !== void 0 ? _a : fallbackProperty; };
const normalizeAttributes = (attributes, theme) => {
    if (!attributes) {
        return attributes;
    }
    const returnValue = {};
    Object.keys(attributes).forEach((key) => {
        const { value, name } = attributes[key];
        const computedValue = !!theme ? theme[name] : `var(--goto-${name})`;
        const propertyName = !!theme ? camelize(key) : key;
        const styleValue = value !== null && value !== void 0 ? value : computedValue;
        returnValue[propertyName] = styleValue;
    });
    return returnValue;
};
const applyVariants = ({ component, returnValue, theme, size }) => {
    var _a, _b, _c, _d;
    const sizeName = size ? `-${size.name}` : '';
    (_a = component.children) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
        var _a, _b;
        returnValue[camelize(getPropertyName(child, `${component.name}${sizeName}-${child.name}`))] = normalizeAttributes(child.attributes, theme);
        (_a = child.states) === null || _a === void 0 ? void 0 : _a.forEach((childState) => {
            returnValue[camelize(getPropertyName(childState, `${component.name}${sizeName}-${child.name}-${childState.name}`))] = normalizeAttributes(childState.attributes, theme);
        });
        (_b = child.children) === null || _b === void 0 ? void 0 : _b.forEach((subChildrenState) => {
            var _a;
            returnValue[camelize(getPropertyName(subChildrenState, `${component.name}${sizeName}-${child.name}-${subChildrenState.name}`))] = normalizeAttributes(subChildrenState.attributes, theme);
            (_a = subChildrenState.states) === null || _a === void 0 ? void 0 : _a.forEach((subChildState) => {
                returnValue[camelize(getPropertyName(subChildState, `${component.name}${sizeName}-${subChildrenState.name}-${subChildState.name}`))] = normalizeAttributes(subChildState.attributes, theme);
            });
        });
    });
    (_b = component.states) === null || _b === void 0 ? void 0 : _b.forEach((state) => {
        returnValue[camelize(getPropertyName(state, `${component.name}${sizeName}-${state.name}`))] = normalizeAttributes(state.attributes, theme);
    });
    if (size) {
        returnValue[camelize(getPropertyName(size, `${component.name}${sizeName}`))] = normalizeAttributes(size.attributes, theme);
        (_c = size.children) === null || _c === void 0 ? void 0 : _c.forEach((child) => {
            returnValue[camelize(getPropertyName(child, `${component.name}${sizeName}-${child.name}`))] = normalizeAttributes(child.attributes, theme);
        });
    }
    (_d = component.variants) === null || _d === void 0 ? void 0 : _d.forEach((variant) => {
        var _a, _b;
        const variants = size
            ? Object.assign(Object.assign({}, variant.attributes), size.attributes) : variant.attributes;
        returnValue[camelize(getPropertyName(variant, `${component.name}-${variant.name}${sizeName}`))] =
            normalizeAttributes(variants, theme);
        (_a = variant.children) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
            var _a;
            returnValue[camelize(getPropertyName(child, `${component.name}-${variant.name}${sizeName}-${child.name}`))] =
                normalizeAttributes(child.attributes, theme);
            (_a = child.states) === null || _a === void 0 ? void 0 : _a.forEach((childState) => {
                returnValue[camelize(getPropertyName(childState, `${component.name}-${variant.name}${sizeName}-${child.name}-${childState.name}`))] = normalizeAttributes(childState.attributes, theme);
            });
        });
        (_b = variant.states) === null || _b === void 0 ? void 0 : _b.forEach((state) => {
            returnValue[camelize(getPropertyName(state, `${component.name}-${variant.name}${sizeName}-${state.name}`))] =
                normalizeAttributes(state.attributes, theme);
        });
    });
};
export const componentValues = (component, theme) => {
    var _a;
    const returnValue = {};
    returnValue[camelize(component.name)] = normalizeAttributes(component.attributes, theme);
    (_a = component.sizes) === null || _a === void 0 ? void 0 : _a.forEach((size) => {
        applyVariants({ component, returnValue, theme, size });
    });
    applyVariants({ component, returnValue, theme });
    return returnValue;
};
export const getComputedValues = (theme) => {
    let returnValue = {};
    chameleonComponents.forEach((component) => {
        returnValue = Object.assign(Object.assign({}, returnValue), componentValues(component, theme));
    });
    return returnValue;
};
export default getComputedValues();
